import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import ReactTable from "react-table";
import moment from 'moment';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Translate from 'translate';
import TablePagination from 'components/HTMLElements/Table/Pagination';

class MeterModal extends React.Component {
  constructor( props ) {
    super( props );
    this.setDateFormat = this.setDateFormat.bind( this );

  }

  /*componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.getTypes();
    }
  }*/

  setDateFormat( value ){
    const {externalCustomer, dateFormat } = this.props;
    if (externalCustomer === 'lec' || externalCustomer === 'escom') {
      return  moment(value , "YYYY-MM-DD" ).format( dateFormat ) 
    } else if (externalCustomer === 'apu') {
      return  moment.unix( value/1000 ).format( dateFormat )
    } else { 
      return moment.unix( value ).format( dateFormat )
    }
  }

  render() {
    const { data, onClose, open, dateFormat, externalCustomer } = this.props;

    return (
      <Modal little
             modalClassName="col-md-8 max-width-unset client-folder p-0"
             open={open}
             onClose={onClose}>
        <div className="p-3 mb-4 bg-blue">
          <h5 className="m-0 d-inline-block"><Translate id="meter"/> {_.get( data, 'SerialNumber' )}</h5>
        </div>

        <div className="px-3">
          <div className="row">
            <div className="col-md-4">
              <p className="mb-1"><Translate id="brand"/>: {_.get( data, 'Brand', '-' )}</p>
              <p className="m-0"><Translate id="model"/>: {_.get( data, 'Model', '-' )}</p>
            </div>
            <div className="col-md">
              {(externalCustomer !== 'lec' && externalCustomer !== 'apu') &&
                <p className="mb-1">
                  <Translate
                  id="installationDate"/>: {_.get( data, 'InstallationDate' ) ? moment.unix( data.InstallationDate ).format( dateFormat ) : '-'}
                </p>
              }
              {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
                <p className="mb-1">
                  <Translate
                  id="installationDate"/>: {_.get( data, 'InstallationDate' ) ? moment.unix( data.InstallationDate/1000 ).format( dateFormat ) : '-'}
                </p>
              }
              {externalCustomer === 'apu' &&
                <p className="mb-1">
                  <Translate
                  id="installationDate"/>: {_.get( data, 'InstallationDate' ) ? moment.unix( data.InstallationDate/1000 ).format( dateFormat ) : '-'}
                </p>
              }
              <p className="m-0"><Translate id="status"/>: {_.get( data, 'Status', '-' )}</p>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <h6><Translate id="readings"/></h6>
              <ReactTable className="app-table -highlight app-table-white"
                          data={_.get( data, 'Readings' )}
                          //pageSize={_.get( data, 'Readings' ) ? data.Readings.length : 0}
                          resizable={false}
                          sortable={false}
                          showPaginationBottom={false}
                          //showPaginationTop={false}
                          
                          defaultSorted={[{ id: 'date', desc: true }]}
                          defaultPageSize={10}
                          minRows={0}
                          resizable={false}
                          showPaginationBottom={false}
                          showPaginationTop
                          previousText={<Translate id='Previous'/>}
                          nextText={<Translate id='Next'/>}
                          loadingText={<Translate id='Loading'/>}
                          noDataText={<Translate id='NoRowsFound'/>}
                          pageText={<Translate id='Page'/>}
                          ofText={<Translate id='of'/>}
                          rowsText={<Translate id='rows'/>}
                          columns={[
                            {
                              Header: <Translate id="date"/>, accessor: 'ReadingDate',
                              Cell: props => props.value ? this.setDateFormat(props.value): ''
                            },
                            { Header: <Translate id="Readings"/>, accessor: 'Readings' },
                            { Header: <Translate id="Consumption"/>, accessor: 'Consumption' },
                            { Header: <Translate id="Type"/>, accessor: 'ReadingType' },
                            {
                              Header: <Translate id="Real"/>, accessor: 'Real',
                              Cell: props => props.value ? <i className="fa fa-check"/> : <i className="fa fa-times"/>
                            },
                          ]}
                          PaginationComponent={( props ) =>
                            <TablePagination {...props} showPageSizeOptions={false}/>
                          }
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCustomer: state.settings.externalCustomer,
} );
export default injectIntl( connect( mapStateToProps )( MeterModal ) );


// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/MeterModal/index.js